export default function internalSystemOptionDirective() {
  return {
    template: require('./internal-system-option.html'),
    scope: {
      customerId: '<',
      department: '=',
      process: '=',
      function: '=',
      internalSystemOption: '=',
      isEdit: '<',
    },
    controller: 'InternalSystemOptionController',
    controllerAs: 'internalSystemOptionVM',
    bindToController: true,
    replace: true,
  };
}
